exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.back[data-v-54b63dd2] {\r\n  border: transparent;\r\n  background: transparent;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: inherit;\n}\n.back > .dbc-icon[data-v-54b63dd2] {\r\n  margin-right: 10px;\r\n  font-size: 1.2em;\r\n  padding: 0;\n}\n.grtid-menu-header[data-v-54b63dd2] {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: justify;\r\n      justify-content: space-between;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 5% 5% 0 5%;\n}\n.grtid-menu-header > .title[data-v-54b63dd2] {\r\n  color: inherit;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 0.8em;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-54b63dd2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/home-page-components/grid-menu-component.vue
// module id = 588
// module chunks = 0